import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { setDefaultBrowserLanguage, navigatorLanguage } from 'Utilities'
import en from './en'
import ko from './ko'
import ja from './ja'
import zhHans from './zh-hans'
import zhHant from './zh-hant'
import id from './in'
import th from './thai'
import ar from './arabic'

Vue.use(VueI18n)

let locale = setDefaultBrowserLanguage(navigatorLanguage())
try {
  // somehow triplaLocalStorage module is not ready to use here when it's imported among other modules
  const localeInLocalStorage = localStorage.getItem('triplabot_locale')
  if (localeInLocalStorage) {
    locale = localeInLocalStorage
  }
} catch (e) {
  // localStorage is not available
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en',
  messages: {
    en,
    ja,
    ko,
    zh_Hans: zhHans,
    zh_Hant: zhHant,
    id: id,
    th: th,
    ar: ar
  }
})

export default i18n
